export default __webpack_public_path__ + "static/media/GlyGen-general-slides.18ac4e65.pptx";